import { render } from "./PolicyGroup.vue?vue&type=template&id=657d6123"
import script from "./PolicyGroup.vue?vue&type=script&lang=js"
export * from "./PolicyGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__